// Правила расчёта периода оплаты хранения (пополнение баланса).
// Единственное место, где описана шкала скидок: чтобы изменить её,
// достаточно поправить DISCOUNT_TIERS. Бэкенд считает бонус по тем же
// диапазонам (задача AMB-426), значения должны совпадать.

// Расчётный период по оферте (п. 9.4.1) - 30 календарных дней.
export const BILLING_PERIOD_DAYS = 30;

export const MIN_MONTHS = 1;
export const MAX_MONTHS = 12;
export const DEFAULT_MONTHS = 3;

// Быстрые кнопки над списком - самые популярные периоды.
export const POPULAR_MONTHS = [3, 6, 12];
export const BEST_PRICE_MONTHS = 12;

// Скидка действует от fromMonths месяцев и до следующей ступени.
// Порядок: от большей ступени к меньшей.
export const DISCOUNT_TIERS = [
  { fromMonths: 12, percent: 10 },
  { fromMonths: 6, percent: 5 },
  { fromMonths: 3, percent: 3 },
];

const round2 = (value) => Math.round(value * 100) / 100;

export function getDiscountPercent(months) {
  const tier = DISCOUNT_TIERS.find((item) => months >= item.fromMonths);
  return tier ? tier.percent : 0;
}

/** 1 -> "1 месяц", 3 -> "3 месяца", 12 -> "12 месяцев" */
export function pluralizeMonths(months) {
  const lastTwo = months % 100;
  const last = months % 10;
  if (lastTwo >= 11 && lastTwo <= 14) return `${months} месяцев`;
  if (last === 1) return `${months} месяц`;
  if (last >= 2 && last <= 4) return `${months} месяца`;
  return `${months} месяцев`;
}

/** "3–5 мес. — 3%, 6–11 мес. — 5%, 12 мес. — 10%" (собирается из DISCOUNT_TIERS) */
export function getDiscountLadderText() {
  const ascending = [...DISCOUNT_TIERS].reverse();
  return ascending
    .map((tier, index) => {
      const next = ascending[index + 1];
      const to = next ? next.fromMonths - 1 : MAX_MONTHS;
      const range =
        to > tier.fromMonths ? `${tier.fromMonths}–${to}` : `${tier.fromMonths}`;
      return `${range} мес. — ${tier.percent}%`;
    })
    .join(', ');
}

/** Расчёт стоимости периода. Суммы округлены до копеек. */
export function getPeriodPricing(monthlyRate, months) {
  const rate = Number(monthlyRate) || 0;
  const percent = getDiscountPercent(months);
  const full = round2(rate * months);
  const total = round2(full * (1 - percent / 100));
  return {
    months,
    percent,
    full,
    total,
    saving: round2(full - total),
    days: months * BILLING_PERIOD_DAYS,
  };
}
